const homeStyles = (theme) => ({
  root: {},
});

export default homeStyles;
